import { z } from 'zod';
import {
    DealerCreateForm,
    DealerCreateFormErrors,
    DealerCreateFormErrorsSchema,
} from '@/types/dealer/dealer-create-form.type.ts';
import { DealerStatus } from '@/types/dealer/dealer-status.type.ts';

export type DealerUpdateForm = DealerCreateForm & {
    status: DealerStatus,
};

export type DealerUpdateFormErrors = DealerCreateFormErrors & {
    status?: string[],
};

export const DealerUpdateFormErrorsSchema = DealerCreateFormErrorsSchema.extend({
    status: z.array(z.string()).optional(),
});
